import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private message1Subject = new BehaviorSubject<string>('Loading...');
  private message2Subject = new BehaviorSubject<string>('');
  private transparentOverlaySubject = new BehaviorSubject<boolean>(false);

  loading$ = this.loadingSubject.asObservable();
  message1$ = this.message1Subject.asObservable();
  message2$ = this.message2Subject.asObservable();
  transparentOverlay$ = this.transparentOverlaySubject.asObservable();

  /** True when the global app loader is showing. */
  get isBusy(): boolean {
    return this.loadingSubject.value === true;
  }

  /**
   * True when the global loader or a visible page overlay (e.g. item-details custom loader) is active.
   * Used to block user-initiated logout / Alt+L while work is in progress.
   */
  isAnyUiLoaderActive(): boolean {
    if (this.isBusy) {
      return true;
    }
    if (typeof document === 'undefined') {
      return false;
    }
    return !!document.querySelector('.custom-loader-overlay, .custom-loader-overlay-transparent');
  }

  show(message1: string = 'Loading...', message2: string = '', transparentOverlay: boolean = false) {
    this.message1Subject.next(message1);
    this.message2Subject.next(message2);
    this.transparentOverlaySubject.next(transparentOverlay);
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
    this.transparentOverlaySubject.next(false);
  }
}
